var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['c-bcx-people-icon', `icon-${_vm.icon.toLocaleLowerCase()}`]},[_c(_vm.iconComponent,{tag:"component",attrs:{"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }